import { useContext } from 'use-context-selector';
import 'react';
import '@emotion/react';
import '../contexts/internal/StickyContext.js';
import { EditorContext } from '../contexts/internal/EditorContext.js';

function useEditor() {
  var contextData = useContext(EditorContext);
  if (contextData == null) {
    throw new Error('EditorContext is not in the scope');
  }
  return contextData;
}

export { useEditor };
//# sourceMappingURL=useEditor.js.map
